import { useMediaQuery } from '@mui/material';
import { useTheme } from '@classify/react-core-components/styles';

// From MUI doc: https://mui.com/components/use-media-query/#migrating-from-withwidth
export default function useWidthidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return keys.reduce((output, key) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const matches = useMediaQuery(theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || 'xs';
}